/**
 * Single source of truth for the résumé download.
 * If the PDF is renamed, update this import only.
 */
import ResumePdf from '../assets/Fantahun_Fekadu_Resume_Lead_FullStack.pdf';

export default ResumePdf;
